// extracted by mini-css-extract-plugin
module.exports = {"container":"community-buzz-carousel_container__sJKY9"};